var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rowModel[_vm.configModel.model])?_c('div',{staticClass:"tag-item"},[_vm._v(" "+_vm._s(_vm.tableText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }